import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { UserOrdersPage } from '../types/user.types';

export interface UserOrdersCardProps {
  orders: UserOrdersPage | undefined;
  loading?: boolean;
  error?: string | null;
  currentPage: number;
  onPageChange: (page: number) => void;
}

export function UserOrdersCard({ orders, loading = false, error, currentPage, onPageChange }: UserOrdersCardProps) {
  const totalPages = Math.max(1, orders?.totalPages ?? 1);

  return (
    <Card className="vania-user-workspace-card vania-user-profile-full-width-card">
      <h2 className="vania-user-workspace-card-title">سفارش‌ها</h2>
      {orders ? (
        <p className="vania-user-profile-card-meta">
          تعداد کل: {formatPersianNumber(orders.totalCount)}
        </p>
      ) : null}
      {loading ? <div className="vania-user-profile-state">در حال بارگذاری سفارش‌ها…</div> : null}
      {!loading && error ? <div className="vania-user-profile-state is-error" role="alert">{error}</div> : null}
      {!loading && !error && !orders ? <div className="vania-user-profile-state is-error" role="alert">اطلاعات سفارش‌ها در دسترس نیست.</div> : null}
      {!loading && !error && orders && orders.items.length === 0 ? (
        <div className="vania-user-profile-state">سفارشی برای این کاربر ثبت نشده است.</div>
      ) : null}
      {!loading && !error && orders && orders.items.length > 0 ? (
        <>
          <div className="vania-user-profile-data-scroll">
            <table className="vania-user-profile-orders-table">
              <thead>
                <tr>
                  <th>سفارش</th>
                  <th>پلن</th>
                  <th>وضعیت</th>
                  <th>مبلغ</th>
                  <th>تاریخ</th>
                </tr>
              </thead>
              <tbody>
                {orders.items.map((order) => (
                  <tr key={order.id}>
                    <td dir="ltr">#{formatPersianNumber(order.id)}</td>
                    <td>{order.planName}</td>
                    <td>{order.status}</td>
                    <td dir="ltr">{order.amount === null ? '—' : `${formatPersianNumber(order.amount)} تومان`}</td>
                    <td dir="ltr">{formatSolarDate(order.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 ? (
            <div className="vania-user-profile-pagination" dir="rtl">
              <button type="button" disabled={currentPage <= 1 || loading} onClick={() => onPageChange(currentPage - 1)}>قبلی</button>
              <span>صفحه {formatPersianNumber(currentPage)} از {formatPersianNumber(totalPages)}</span>
              <button type="button" disabled={currentPage >= totalPages || loading} onClick={() => onPageChange(currentPage + 1)}>بعدی</button>
            </div>
          ) : null}
        </>
      ) : null}
    </Card>
  );
}
